import * as actionType from "./constants";
import axios from "axios";
import { socketConnect } from "../messages/actions";
import { getRooms } from "../rooms/actions";
import { getRoomGroups } from "../rooms/groups/actions";
import { getCleaningList } from "../cleaning/actions";
import { getUsers } from "../users/actions";
import { getOccupancy } from "../rooms/occupancy/actions";

export const createHotel = hotel => {
  return (dispatch, getState) => {
    const { userId } = getState().account.user;
    let data = {
      userId,
      hotel
    };
    dispatch({ type: actionType.CREATE_HOTEL_REQUEST });
    return axios
      .post("/hotel", data)
      .then(response => {
        dispatch({
          type: actionType.CREATE_HOTEL_SUCCESS,
          hotel: response.data
        });
      })
      .catch(err => {
        dispatch({ type: actionType.CREATE_HOTEL_REJECT, err });
      });
  };
};

export const removeHotel = hotel => {
  return dispatch => {
    dispatch({ type: actionType.REMOVE_HOTEL_REQUEST });

    return axios
      .delete(`/hotel/${hotel.hotelId}`)
      .then(() => {
        dispatch({
          type: actionType.REMOVE_HOTEL_SUCCESS,
          hotel: hotel
        });
      })
      .catch(err => {
        dispatch({ type: actionType.REMOVE_HOTEL_REJECT, err });
      });
  };
};

export const selectHotel = selected => {
  return async dispatch => {
    dispatch(changeHotel(selected));
    await dispatch(socketConnect());
    await dispatch(getRooms());
    await dispatch(getRoomGroups());
    await dispatch(getCleaningList());
    await dispatch(getUsers());
    await dispatch(getOccupancy());
  };
};

const changeHotel = selected => ({
  type: actionType.CHANGE_HOTEL,
  selected
});

export const getHotels = () => {
  return (dispatch, getState) => {
    const { userId } = getState().account.user;
    dispatch({ type: actionType.GET_HOTEL_REQUEST });
    return axios
      .get("/hotel/user/" + userId)
      .then(response => {
        dispatch({
          type: actionType.GET_HOTEL_SUCCESS,
          hotels: response.data
        });
        if (response.data.length > 0) {
          dispatch(changeHotel(response.data[0].hotelId));
        }
      })
      .catch(err => {
        dispatch({ type: actionType.GET_HOTEL_REJECT, err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/hotels/actions.js